import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UsersIcon, BarChartIcon, CreditCardIcon, TrendingUpIcon, ClockIcon, CheckIcon, ArrowRightIcon, BriefcaseIcon, HeartIcon, StarIcon } from 'lucide-react';
const SellerInfo = () => {
  return <div className="pb-16" data-id="element-3209">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-3210">
        <div className="max-w-4xl mx-auto p-4" data-id="element-3211">
          <h1 className="text-2xl font-bold mb-2" data-id="element-3212">
            Partner with JoinToday.co.ke
          </h1>
          <p className="text-gray-600 dark:text-gray-300" data-id="element-3213">
            Grow your business, sell tickets, and reach more customers
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-3214">
        <div className="mb-8" data-id="element-3215">
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-6" data-id="element-3216">
            <h2 className="text-xl font-bold mb-4" data-id="element-3217">Why Partner With Us?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3218">
              <div data-id="element-3219">
                <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4" data-id="element-3220">
                  <UsersIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-3221" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-3222">Reach a Wider Audience</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3223">
                  Connect with thousands of active users across Kenya looking
                  for events and experiences.
                </p>
              </div>
              <div data-id="element-3224">
                <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4" data-id="element-3225">
                  <CreditCardIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-3226" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-3227">Seamless Ticketing</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3228">
                  Easy-to-use ticketing platform with secure payment processing
                  and real-time sales tracking.
                </p>
              </div>
              <div data-id="element-3229">
                <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4" data-id="element-3230">
                  <BarChartIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-3231" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-3232">Powerful Analytics</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3233">
                  Gain insights into your audience, track sales performance, and
                  optimize your marketing.
                </p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-3234">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3235">
              <h2 className="text-xl font-bold mb-4" data-id="element-3236">Event Organizer</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3237">
                Create and manage your own events, sell tickets, and grow your
                audience.
              </p>
              <ul className="space-y-3 mb-6" data-id="element-3238">
                <li className="flex items-start" data-id="element-3239">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3240" />
                  <span className="text-sm" data-id="element-3241">Create unlimited events</span>
                </li>
                <li className="flex items-start" data-id="element-3242">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3243" />
                  <span className="text-sm" data-id="element-3244">Customizable event pages</span>
                </li>
                <li className="flex items-start" data-id="element-3245">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3246" />
                  <span className="text-sm" data-id="element-3247">Multiple ticket types</span>
                </li>
                <li className="flex items-start" data-id="element-3248">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3249" />
                  <span className="text-sm" data-id="element-3250">Attendee management</span>
                </li>
                <li className="flex items-start" data-id="element-3251">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3252" />
                  <span className="text-sm" data-id="element-3253">Promotional tools</span>
                </li>
              </ul>
              <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-md mb-6" data-id="element-3254">
                <p className="text-sm font-medium" data-id="element-3255">Commission Rate:</p>
                <p className="text-2xl font-bold" data-id="element-3256">15%</p>
                <p className="text-xs text-gray-600 dark:text-gray-300 mt-1" data-id="element-3257">
                  Standard rate on ticket sales
                </p>
              </div>
              <Link to="/register?type=seller" className="block text-center w-full bg-gray-800 text-white rounded-md py-2" data-id="element-3258">
                Become an Event Organizer
              </Link>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3259">
              <h2 className="text-xl font-bold mb-4" data-id="element-3260">Event Influencer</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3261">
                Promote events to your audience and earn commission on ticket
                sales.
              </p>
              <ul className="space-y-3 mb-6" data-id="element-3262">
                <li className="flex items-start" data-id="element-3263">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3264" />
                  <span className="text-sm" data-id="element-3265">Unique referral links</span>
                </li>
                <li className="flex items-start" data-id="element-3266">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3267" />
                  <span className="text-sm" data-id="element-3268">Real-time commission tracking</span>
                </li>
                <li className="flex items-start" data-id="element-3269">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3270" />
                  <span className="text-sm" data-id="element-3271">Promotional materials</span>
                </li>
                <li className="flex items-start" data-id="element-3272">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3273" />
                  <span className="text-sm" data-id="element-3274">Performance analytics</span>
                </li>
                <li className="flex items-start" data-id="element-3275">
                  <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3276" />
                  <span className="text-sm" data-id="element-3277">Monthly payouts</span>
                </li>
              </ul>
              <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-md mb-6" data-id="element-3278">
                <p className="text-sm font-medium" data-id="element-3279">Commission Rate:</p>
                <p className="text-2xl font-bold" data-id="element-3280">5-10%</p>
                <p className="text-xs text-gray-600 dark:text-gray-300 mt-1" data-id="element-3281">
                  Per ticket sold through your referral
                </p>
              </div>
              <Link to="/register?type=influencer" className="block text-center w-full bg-gray-800 text-white rounded-md py-2" data-id="element-3282">
                Become an Event Influencer
              </Link>
            </div>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-8" data-id="element-3283">
            <h2 className="text-xl font-bold mb-4" data-id="element-3284">
              Venue & Service Provider Partnerships
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3285">
              Are you a venue owner or service provider for events? Partner with
              us to reach more clients.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3286">
              <div data-id="element-3287">
                <h3 className="font-bold mb-2" data-id="element-3288">For Venues</h3>
                <ul className="space-y-2" data-id="element-3289">
                  <li className="flex items-start" data-id="element-3290">
                    <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3291" />
                    <span className="text-sm" data-id="element-3292">
                      List your venue in our directory
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3293">
                    <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3294" />
                    <span className="text-sm" data-id="element-3295">Get booking inquiries</span>
                  </li>
                  <li className="flex items-start" data-id="element-3296">
                    <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3297" />
                    <span className="text-sm" data-id="element-3298">
                      Showcase your space with photos
                    </span>
                  </li>
                </ul>
              </div>
              <div data-id="element-3299">
                <h3 className="font-bold mb-2" data-id="element-3300">For Service Providers</h3>
                <ul className="space-y-2" data-id="element-3301">
                  <li className="flex items-start" data-id="element-3302">
                    <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3303" />
                    <span className="text-sm" data-id="element-3304">
                      Catering, decor, sound, lighting, etc.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3305">
                    <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3306" />
                    <span className="text-sm" data-id="element-3307">
                      Connect with event organizers
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3308">
                    <CheckIcon className="w-5 h-5 mr-2 text-gray-600 dark:text-gray-300" data-id="element-3309" />
                    <span className="text-sm" data-id="element-3310">
                      Build your service portfolio
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <Link to="/contact-partnerships" className="flex items-center justify-center w-full border border-gray-300 dark:border-gray-600 rounded-md py-2" data-id="element-3311">
              <span className="mr-2" data-id="element-3312">Contact Our Partnerships Team</span>
              <ArrowRightIcon className="w-4 h-4" data-id="element-3313" />
            </Link>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-8" data-id="element-3314">
            <div className="p-6" data-id="element-3315">
              <h2 className="text-xl font-bold mb-4" data-id="element-3316">Success Stories</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3317">
                <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3318">
                  <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full mb-3 flex items-center justify-center" data-id="element-3319">
                    <CalendarIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-3320" />
                  </div>
                  <h3 className="font-bold mb-1" data-id="element-3321">Nairobi Music Festival</h3>
                  <p className="text-xs text-gray-600 dark:text-gray-300 mb-2" data-id="element-3322">
                    Event Organizer
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3323">
                    "We increased our ticket sales by 45% by using JoinToday's
                    platform."
                  </p>
                </div>
                <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3324">
                  <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full mb-3 flex items-center justify-center" data-id="element-3325">
                    <BriefcaseIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-3326" />
                  </div>
                  <h3 className="font-bold mb-1" data-id="element-3327">Tech Meetup Kenya</h3>
                  <p className="text-xs text-gray-600 dark:text-gray-300 mb-2" data-id="element-3328">
                    Community Organizer
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3329">
                    "Our community grew from 200 to over 1,000 members in just 6
                    months."
                  </p>
                </div>
                <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3330">
                  <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full mb-3 flex items-center justify-center" data-id="element-3331">
                    <HeartIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-3332" />
                  </div>
                  <h3 className="font-bold mb-1" data-id="element-3333">Sarah N.</h3>
                  <p className="text-xs text-gray-600 dark:text-gray-300 mb-2" data-id="element-3334">
                    Event Influencer
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3335">
                    "I earned over KES 50,000 in commissions in my first month
                    as an influencer."
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mb-8" data-id="element-3336">
            <h2 className="text-xl font-bold mb-4" data-id="element-3337">Ready to Get Started?</h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-3338">
              <Link to="/register?type=seller" className="bg-gray-800 text-white rounded-md px-6 py-3 flex items-center justify-center" data-id="element-3339">
                <span className="mr-2" data-id="element-3340">Create Partner Account</span>
                <ArrowRightIcon className="w-4 h-4" data-id="element-3341" />
              </Link>
              <Link to="/seller-login" className="border border-gray-300 dark:border-gray-600 rounded-md px-6 py-3" data-id="element-3342">
                Log In to Partner Account
              </Link>
            </div>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3343">
            <h2 className="text-xl font-bold mb-4" data-id="element-3344">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4" data-id="element-3345">
              <div data-id="element-3346">
                <h3 className="font-bold mb-2" data-id="element-3347">
                  How do I get paid for ticket sales?
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3348">
                  We process payments weekly via M-Pesa or bank transfer. You'll
                  receive your funds minus our commission.
                </p>
              </div>
              <div data-id="element-3349">
                <h3 className="font-bold mb-2" data-id="element-3350">
                  What types of events can I create?
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3351">
                  You can create various types of events including concerts,
                  workshops, conferences, meetups, and more.
                </p>
              </div>
              <div data-id="element-3352">
                <h3 className="font-bold mb-2" data-id="element-3353">How do I promote my events?</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3354">
                  Your events will be promoted on our platform, and we provide
                  tools for social media sharing and email marketing.
                </p>
              </div>
              <div data-id="element-3355">
                <h3 className="font-bold mb-2" data-id="element-3356">
                  Can I offer different ticket types?
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3357">
                  Yes, you can create multiple ticket types with different
                  prices, such as Early Bird, Regular, VIP, etc.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default SellerInfo;